import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  GetSystemadminChildList,
  GetSystemadminLeaveList,
  SystemadminSpecificEmployeeView
} from "../../Repository/Api";
import { errorMsg } from "../Toastify";
import { useSelector } from "react-redux";
const SystemadminEmployeeSpecificView = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  const [specificEmployee, setSpecificEmployee] = useState({});
  const [leaveList, setLeaveList] = useState([]);
  const [childList, setChildList] = useState([]);
  const [active, setActive] = useState(0);
  const links = ["Basic Info", "Leave Info", "Child Info"];
  const showSelected = (index) => {
    setActive(index);
  };

  useEffect(() => {
    getSpecificEmployee();
    getLeaveList();
    getChildList();
  },[]);

  const getSpecificEmployee = async () => {
    const response = await SystemadminSpecificEmployeeView(id, token);
    if (response && response.statusCode === 200) {
      setSpecificEmployee(response.data);
    } else {
      errorMsg(response.message);
    }
  };
  const getLeaveList = async () => {
    const response = await GetSystemadminLeaveList(id, token);
    if (response && response.statusCode === 200) {
      setLeaveList(response?.data?.leave_details);
    } else {
      errorMsg(response.message);
    }
  };
  const getChildList = async () => {
    const response = await GetSystemadminChildList(id, token);
    if (response && response.statusCode === 200) {
      setChildList(response?.data);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} {last_name}
                </h6>
              </div>
            </div>
          </div>
        </section>
        <section className="my-4">
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Employee List
                </h6>
                {specificEmployee?.user_type_value === "employee" ? (
                  <div className="row">
                    <div className="col-lg-4 mx-auto ms-auto">
                      <ul className="searchtopflex">
                        {links.map((link, index) => {
                          return (
                            <li
                              onClick={() => showSelected(index)}
                              key={link}
                              className={
                                active === index
                                  ? "agenttextactive"
                                  : "agenttextinactive"
                              }
                            >
                              {link}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {active === 0 && (
                  <div className="row">
                    <div className="col-lg-3">
                      <label className="labeltext">Name of the Applicant</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.first_name}
                        disabled
                      />
                    </div>
                    <div className="col-lg-3">
                      <label className="labeltext">Last Name</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.last_name}
                        disabled
                      />
                    </div>
                    {specificEmployee?.user_type_value === "employee" ? (
                      <div className="col-lg-3">
                        <label className="labeltext">Designation</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={specificEmployee?.designation}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {specificEmployee?.user_type_value === "admin" ||
                      specificEmployee?.user_type_value === "director" ||
                      specificEmployee?.user_type_value === "store_incharge" ? (
                      ""
                    ) : (
                      <div className="col-lg-3">
                        <label className="labeltext">Department</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={specificEmployee?.department}
                          disabled
                        />
                      </div>
                    )}
                    {specificEmployee?.user_type_value === "employee" ? (
                      <div className="col-lg-3">
                        <label className="labeltext"> Employee ID </label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={specificEmployee?.employee_id}
                          disabled
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {specificEmployee?.user_type_value === "indent" ? (
                      <div className="col-lg-3">
                        <label className="labeltext"> Employee ID </label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={specificEmployee?.employee_id}
                          disabled
                        />
                      </div>
                    ) : (
                      <div className="col-lg-3">
                        <label className="labeltext">Email ID</label>
                        <input
                          type="text"
                          className="fieldinputemail"
                          value={specificEmployee?.email_id}
                          disabled
                        />
                      </div>
                    )}

                    <div className="col-lg-3">
                      <label className="labeltext">Phone Number</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.phone_number}
                        disabled
                      />
                    </div>
                    {specificEmployee?.user_type_value === "employee" ? (
                      <>
                        <div className="col-lg-3">
                          <label className="labeltext"> Gender</label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={specificEmployee?.gender}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext"> Father's Name</label>
                          <input
                            type="text"
                            className="fieldinput"
                            defaultValue={specificEmployee?.father_name}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext">Date Of Birth</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={moment(specificEmployee?.dob).format(
                              "DD-MM-yyyy"
                            )}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext">Date Of Join</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={moment(specificEmployee?.doj).format(
                              "DD-MM-yyyy"
                            )}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext">Staff Type</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={specificEmployee?.officer_type}
                            disabled
                          />
                        </div>
                        <div className="col-lg-3">
                          <label className="labeltext">Marital Status</label>
                          <input
                            type="text"
                            className="fieldinput"
                            value={specificEmployee?.marital_status}
                            disabled
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                )}
                {active === 1 && (
                  <table className="table table-hover mt-5">
                    <thead>
                      <tr>
                        <th scope="col">Duration</th>
                        <th scope="col">Days</th>
                        <th scope="col">Types</th>
                        <th scope="col">HOD</th>
                        <th scope="col">Admin</th>
                        <th scope="col">Director</th>
                        <th scope="col">Application</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leaveList.length > 0 ? (
                        leaveList &&
                        leaveList?.map((leave, index) => (
                          <tr key={index}>
                            <td>
                              {moment(leave?.start_date).format("DD MMM YY")} -{" "}
                              {moment(leave?.end_date).format("DD MMM YY")}
                            </td>
                            <td>
                              {leave?.no_of_days ? leave?.no_of_days : "-"}
                            </td>
                            <td>
                              {leave?.nature_of_leave
                                ? leave?.nature_of_leave
                                : "-"}
                            </td>
                            <td
                              className={
                                leave?.hod_status === "approved"
                                  ? "till-active"
                                  : "not-active-wait" &&
                                    leave?.hod_status === "rejected"
                                    ? "not-active"
                                    : "not-active-wait"
                              }
                            >
                              {leave?.hod_status ? leave?.hod_status : "-"}
                            </td>
                            <td
                              className={
                                leave?.admin_status === "forwarded"
                                  ? "till-active"
                                  : "not-active-wait"
                              }
                            >
                              {leave?.admin_status ? leave?.admin_status : "-"}
                            </td>
                            <td
                              className={
                                leave?.director_status === "approved"
                                  ? "till-active"
                                  : "not-active-wait" &&
                                    leave?.director_status === "rejected"
                                    ? "not-active"
                                    : "not-active-wait"
                              }
                            >
                              {leave?.director_status
                                ? leave?.director_status
                                : "-"}
                            </td>
                            <td className="viewoption">
                              <Link
                                to={`/app/Systemadmin/SystemadminEmployeeleavespecific/${leave?.id}`}
                              >
                                View Details
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
                {active === 2 && (
                  <table className="table table-hover mt-5">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Gender</th>
                        <th scope="col">Date of Birth</th>
                        <th scope="col">Application</th>
                      </tr>
                    </thead>
                    <tbody>
                      {childList.length > 0 ? (
                        childList &&
                        childList?.map((child, index) => (
                          <tr key={index}>
                            <td>{child?.name ? child?.name : "-"}</td>
                            <td>{child?.gender ? child?.gender : "-"}</td>
                            <td>{moment(child?.dob).format("DD MMM YYYY")}</td>
                            <td className="viewoption">
                              <Link
                                to={`/app/Systemadmin/SystemadminEmployeechildspecific/${child?.id}`}
                              >
                                View Details
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SystemadminEmployeeSpecificView;
